module.exports = __webpack_public_path__ + "img/Pack_check_up_annuel.eb26c626.jpg";